<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 년도 -->
          <c-datepicker
            :range="true"
            type="year"
            default="today"
            label="LBLYEAR"
            name="years"
            v-model="searchParam.years"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            type="search"
            stepperGrpCd="HEA_MUSCLE_SOP_STEP_CD"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="heaMuscleSopStepCd"
            label="LBLSTEPPROGRESS"
            v-model="searchParam.heaMuscleSopStepCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      title="근골격계 조사 목록"
      :merge="grid.merge"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'hazardInvestigation',
  data() {
    return {
      searchParam: {
        plantCd: null,
        years: [],
        heaMuscleSopStepCd: null,
      },
      grid: {
        merge: [
          { index: 0, colName: 'heaInvestigationPlanId', },
          { index: 1, colName: 'heaInvestigationPlanId', },
          { index: 2, colName: 'heaInvestigationPlanId', },
          { index: 3, colName: 'heaMuscleSopId', },
          { index: 4, colName: 'heaMuscleSopId', },
          { index: 5, colName: 'heaMuscleSopId', },
        ],
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            sortable: false,
            style: 'width:100px',
          },
          {
            name: 'investigationPlanName',
            field: 'investigationPlanName',
            label: '조사계획명',
            align: 'left',
            sortable: false,
            style: 'width:250px',
          },
          {
            name: 'year',
            field: 'year',
            label: 'LBLYEAR',
            align: 'center',
            sortable: false,
            style: 'width:80px',
          },
          {
            name: 'processName',
            field: 'processName',
            label: 'LBLPROCESS',
            align: 'center',
            sortable: false,
            style: 'width:100px',
          },
          {
            name: 'sopName',
            field: 'sopName',
            label: '단위작업',
            align: 'left',
            sortable: false,
            style: 'width:120px',
            type: 'link'
          },
          {
            name: 'heaMuscleSopStepName',
            field: 'heaMuscleSopStepName',
            label: 'LBLSTEPPROGRESS',
            align: 'center',
            sortable: false,
            style: 'width:100px',
          },
          {
            name: 'heavyWorkName',
            field: 'heavyWorkName',
            label: '부담작업No',
            align: 'center',
            sortable: false,
            style: 'width:90px',
          },
          {
            name: 'detailJobContents',
            field: 'detailJobContents',
            label: '작업내용',
            align: 'left',
            sortable: false,
            style: 'width:220px',
          },
          {
            name: 'workTime',
            field: 'workTime',
            label: '작업시간',
            align: 'center',
            sortable: false,
            style: 'width:70px',
          },
          {
            name: 'workCnt',
            field: 'workCnt',
            label: '횟수',
            align: 'center',
            sortable: false,
            style: 'width:70px',
          },
          {
            name: 'result',
            field: 'result',
            label: '결과',
            child: [
              {
                name: 'workTotal',
                field: 'workTotal',
                label: '최종<br/>노출시간',
                align: 'center',
                sortable: false,
                style: 'width:70px',
              },
              {
                name: 'assessResult',
                field: 'assessResult',
                label: '평가결과',
                align: 'center',
                sortable: false,
                style: 'width:80px',
              },
            ]
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.hea.muscleSystem.muscleSop.invest.list.url
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, col) {
      this.popupOptions.title = '근골격계 조사계획';
      this.popupOptions.param = {
        heaMuscleSopId: row.heaMuscleSopId,
      };
      this.popupOptions.target = () => import(`${'./hazardInvestigationDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
